import React from "react";
import ProjectResults from "../components/ProjectResults";
import cfi from '../assets/cfi.png'
import nf from '../assets/nf.png'
import laPlan from '../assets/la_plancha.png'
const ReactProject = () => {
  const listProject=[
     {
      img: cfi,
      name: "CFI Timekeeping System",
      language: "React, Python",
    },
    {
      img: nf,
      name: "Nature Feerique",
      language: "React, Python",
    },
    {
      img: laPlan,
      name: "La Plancha website",
      language: "Python, Fluter, React",
    },
  ]
  return (
    <div>
      <ProjectResults
        name={"React Development"}
        subtext={
          "React is another popular JavaScript library that results in robust web applications. React renders quickly, is easy to maintain, and helps ensure code stability — the latter of which is of course important to end users, who just want an app that works.\n" +
          "\n" +
          "React also has the advantage of being SEO friendly, helping websites boost their Google rankings. Rather than just praying to the spirits of the internet to increase your web presence, you can rely on React to provide some SEO value."
        }
        labelProject={'Our react development'}
        listProject={listProject}
      />
    </div>
  );
};

export default ReactProject;
